import ContextTela from '@pages/DicasOtimizacao/telaContext';
import { useContext } from '@wordpress/element';

export const useTagsHtmlETexto = () => {
  const obterTagsHtmlETextoEditorWp = () => {
    try {
      let elementoHtml = document
      ?.getElementById('editor')
      ?.getElementsByTagName('iframe')[0]
      ?.contentWindow.document?.getElementsByClassName(
        'wp-block-post-content block-editor-block-list__layout'
      );

    if (elementoHtml && elementoHtml.length > 0) {
      return elementoHtml[0];
    }

    elementoHtml = document.getElementsByClassName('is-root-container');

    if (elementoHtml && elementoHtml.length > 0) {
      return elementoHtml[0];
    }

    return null;
    } catch (error) {
      console.error('Erro ao obter tags HTML e texto do editor WordPress:', error);
    }
    
  };

  return { obterTagsHtmlETextoEditorWp };
};

export const useIframeControl = () => {
  const { setIframeLoad } = useContext(ContextTela);

  const carregar = () => {
    setIframeLoad(true);
    document.getElementById('opti_preview_post').contentWindow.location.reload();
  };

  return { carregar };
};
